// extracted by mini-css-extract-plugin
export var modalConfirmStaking = "ModalConfirmStaking_modalConfirmStaking__b34Sk";
export var modalBody = "ModalConfirmStaking_modalBody__1I0g6";
export var textNftCount = "ModalConfirmStaking_textNftCount__F+6Cu";
export var rotate = "ModalConfirmStaking_rotate__vHcZ+";
export var dotty = "ModalConfirmStaking_dotty__5gLso";